
// 中药房门诊发药 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */

// 中药处方发药明细 = 发药
export const tcmFySave = (params) => {
    return request.get("/outpatient/tcmFy/fySave", { params })
}
// 中药处方退药
export const tySave = (data) => {
    return request.post("/outpatient/zyty/addTcmRet", data)
}

/**
 * 
 * get 
 *  
 */

// 中药房门诊发药-查询患者信息
export const tcmDisselectPatientInfo = (params) => {
    return request.get("/outpatient/tcmDis/selectPatientInfo", { params })
}
// 中药房门诊发药-查询患者信息
export const selectPatientInfo = (params) => {
    return request.get("/outpatient/dis/selectPatientInfo", { params })
}
// 中药房门诊退药列表
export const rxmainPage = (params) => {
    return request.get("/outpatient/tcmrxmain/page", { params })
}
// 中药处方列表-点击退药查看退药数据
export const getRefundDrug = (params) => {
    return request.get("/outpatient/zyty/getRefundDrug", { params })
}
export const deltyrefund = (params) => {
    return request.get("/outpatient/zyty/deleteTcmRefund", { params })
}

/**
 * 
 * DELETE 
 *  
 */
// 中药房其他入库草稿删除
// export const deleteDoc = (params) => {
//     return request.delete("/outpatient/dugDoc/deleteDoc", { params })
// }


/*
	Others
*/
// 护理执行计划-查询处方是否有护理执行
export const getDrxExePlanInfo = (params) => {
    return request.get("/outpatient/exetable/getDrxExePlanInfo", { params })
}

// 暴露
export default{
	// 查询患者信息
	tcmDisselectPatientInfo,
	// 发药
	tcmFySave,
	// 退药
	rxmainPage,tySave,getRefundDrug,getDrxExePlanInfo,deltyrefund
}